<rid-reading-matrix-timer
  class="h-dvh"
  [duration]="duration()"
  [matrices]="[
    [
      ['aai', 'aan', 'gaaf', 'mos', 'gum', 'goor'],
      ['guur', 'ijs', 'jaar', 'jas', 'lees', 'jas'],
      ['aai', 'aan', 'gaaf', 'mos', 'gum', 'goor'],
    ],
    [
      ['aai', 'aan', 'gaaf', 'mos', 'gum', 'goor'],
      ['aai', 'aan', 'gaaf', 'mos', 'goor'],
    ],
  ]"
  [previousWordCount]="previousWordCount()"
  (finished)="$router.navigate(['/mechanics/reading-matrix'])"
/>
